import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, ViewChild, ViewContainerRef, ElementRef } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { AppData } from '../../../app-data';
import { DictionaryItem } from '../../../model/api/administration/dictionary-item';
import { AssetEmployeeEdit } from '../../../model/api/assets/asset-employee-edit';
import { AssetEmployeeSave } from '../../../model/api/assets/asset-employee-save';
import { Brand } from '../../../model/api/assets/brand';
import { CodeNameEntity } from '../../../model/api/common/code-name-entity';
import { ConfigValue } from '../../../model/api/common/config-value';
import { EmployeeValidateStatus } from '../../../model/api/common/employee-validate-status';
import { ColumnDefinition } from '../../../model/common/column-definition';
import { PagedResult } from '../../../model/common/paged-result';
import { Param } from '../../../model/common/param';
import { TableDefinition } from '../../../model/common/table-definition';
import { DictionaryItemHttpService } from '../../../services/http/administration/dictionary-item.http.service';
import { EmployeeHttpService } from '../../../services/http/administration/employee.http.service';
import { AssetHttpService } from '../../../services/http/assets/asset.http.service';
import { BrandHttpService } from '../../../services/http/assets/brand.http.service';
import { ColumnDefinitionHttpService } from '../../../services/http/common/column-definition.http.service';
import { ConfigValuesHttpService } from '../../../services/http/common/config-values.service';
import { DashboardHttpService } from '../../../services/http/common/dashboard.http.service';
import { TableDefinitionHttpService } from '../../../services/http/common/table-definition.http.service';
import { NotificationService } from '../../../services/notification.service';
import { DictionaryItemDetailComponent } from '../../administrations/dictionary-item/dictionary-item.detail';
import { DictionaryItemListComponent } from '../../administrations/dictionary-item/dictionary-item.list';
import { BrandList } from '../brands/brand.list';
import { AssetEmployeeValidateList } from './asset-employee-validate.list';
import { EntityFileHttpService } from '../../../services/http/common/entity-file.http.service';
import { EntityFile, AssetImage } from '../../../model/api/common/entity-file';
import { FormBuilder, FormGroup } from '@angular/forms';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
    selector: 'asset-employee-detail-ui',
    templateUrl: 'asset-employee.detail.ui.html',
    styleUrls: ['asset-employee.detail.ui.scss'],
    providers: [ AssetHttpService ]
})
export class AssetEmployeeDetailUI implements AfterViewInit  {

    @ViewChild('assetInvFullDetailList') public assetInvFullDetailList: AssetEmployeeValidateList;

    @ViewChild('dictionaryItemDetail') public dictionaryItemDetail: DictionaryItemDetailComponent;
    @ViewChild('dictionaryItemList') public dictionaryItemList: DictionaryItemListComponent;

    @ViewChild('dictionaryItemDetailModal') public dictionaryItemDetailModal: ModalDirective;
    @ViewChild('dictionaryItemListModal') public dictionaryItemListModal: ModalDirective;

    @ViewChild('brandList') public brandList: BrandList;
    @ViewChild('brandListModal') public brandListModal: ModalDirective;

    @ViewChild('confirmationModal') public confirmationModal: ModalDirective;

    @ViewChild('imageListModal') public imageListModal: ModalDirective;
    @ViewChild('uploadModal') public uploadModal: ModalDirective;
    @ViewChild('fileInput') fileInput: ElementRef;

    public assetEmployee: AssetEmployeeSave = new AssetEmployeeSave();
    public dictionaryItem: CodeNameEntity = null;
    public selectedAsset: AssetEmployeeEdit = null;

    public info: string = '';
    public info2019: string = '';
    public name: string = '';
    public serialNumber: string = '';
    public brandName: string = '';
    public brand: CodeNameEntity = null;
    public assetId = 0;
    guid: string = '';
    isSaved = false;
    public imageCount: number = 0;
    public imageIndex: number = 0;
    public imageLoading: boolean = false;
    private entityTypeCode: string = 'NEWASSETEMPLOYEE';
    private fileEventPhoto: any = null;

    public itemsInventory = new Array<EmployeeValidateStatus>();
    public assetImages: Array<AssetImage> = new Array<AssetImage>();
    public existingAssetImages: Array<AssetImage> = new Array<AssetImage>();
    public assetFiles: Array<EntityFile> = new Array<EntityFile>();

    public confirmationMessage: string = '';
    public operationType: OperationType = OperationType.NotSet;
    imageForm:  FormGroup;

    constructor(
        public route: ActivatedRoute,
        public router: Router,
        public assetHttpService: AssetHttpService,
        public dictionaryItemHttpService: DictionaryItemHttpService,
        public brandHttpService: BrandHttpService,
        public notificationService: NotificationService,
        public employeeHttpService: EmployeeHttpService,
        public dashboardHttpService: DashboardHttpService,
        public tableDefinitionHttpService: TableDefinitionHttpService,
        public columnDefinitionHttpService: ColumnDefinitionHttpService,
        public configValuesHttpService: ConfigValuesHttpService,
        public entityFileHttpService: EntityFileHttpService,
        public http: HttpClient, 
        private fb: FormBuilder ) {

            this.itemsInventory.push(new EmployeeValidateStatus());

            this.route.params.subscribe((params: Params) => {
                if (params['id']) {
                    this.guid = params['id'];
                }
            });
            this.imageForm = this.fb.group({
                image: ['']
              });
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.loadTableConfigurationData('user');
            // this.refreshAssets();
            this.loadData();
       }, 2000);
    }

    public get allowSaving(): boolean {
        if (((this.name != undefined && this.name != '' && this.name.trim().length > 2) && 
        
        (this.serialNumber != undefined && this.serialNumber != '' && this.serialNumber.trim().length > 2))){
            return true
        }
        else{
            return false;
        }
    }

    public onAssetInvFullDetailSelectionChanged(assets: Array<AssetEmployeeSave>) {
        // this.selectedAsset = ((assets != null) && (assets.length === 1)) ? assets[0] : null;

        this.selectedAsset = this.assetInvFullDetailList.selectedItem;

        if (this.selectedAsset != null) {
            this.assetId = this.selectedAsset.id;
            this.info = this.selectedAsset.info;
            this.info2019 = this.selectedAsset.info2019;
            this.name = this.selectedAsset.name;
            this.serialNumber = this.selectedAsset.serialNumberFinal;
            this.brandName = this.selectedAsset.brand != null ? this.selectedAsset.brand.name : '';
            //this.brand = this.selectedAsset.brand;
            //this.dictionaryItem = this.selectedAsset.dictionaryItem;
        } else {
            this.selectedAsset = new AssetEmployeeEdit();
            this.info = '';
            this.info2019 = '';
            this.name = '';
            this.serialNumber = '';
            this.brandName = '';
            this.assetId = 0;
            this.brand = null;
            this.dictionaryItem = null;
        }
    }

    onAssetEmployeeValidateListAfterViewInit() {
    }

    public refreshAssets() {
        let params: Array<Param> = new Array<Param>();

        params.push(new Param('userId', this.guid.toString()));
        this.assetInvFullDetailList.refresh(params);
    }

    public loadFilePhoto(ev) {
        console.log(ev);
        this.fileEventPhoto = ev;
        const fileList: FileList = ev.target.files;
        if (fileList.length > 0) {
            const file: File = fileList[0];
            this.imageForm.get('image').setValue(file);
        }
    }

    public onAssetFileUpload () {
        if(this.assetInvFullDetailList.selectedItems.length === 1){
            this.info = '';
            this.name = '';
            this.serialNumber = '';
            this.assetId = 0;
            debugger
            this.assetId = this.assetInvFullDetailList.selectedItems[0].id;
            this.name = this.assetInvFullDetailList.selectedItems[0].name;
            this.serialNumber = this.assetInvFullDetailList.selectedItems[0].serialNumber;
            this.info = this.assetInvFullDetailList.selectedItems[0].info;
            this.guid = this.guid;
            let fileToUpload = this.imageForm.get('image').value;
            let formData = new FormData();
            formData.append('image', fileToUpload);
            this.entityFileHttpService
                .upload(fileToUpload, this.assetId, this.entityTypeCode, this.info)
                .subscribe(res => {

                });
        }
        else {
            alert('Nu ati selectat un activ! Va rog sa incercati din nou.');
        }
        //this.loadTableConfigurationData();
        //this.refreshEntityEmployeeFiles();
        this.uploadModal.show();

    }

    // private showPhoto(type: string){

    //     this.imageListModal.show();
    //         switch (type) {
    //             case 'ASSET':
    //                 this.refreshEntityFiles(this.assetInvFullDetailList.selectedItem.id, true);
    //                 break;
    //                 case 'NEWASSETEMPLOYEE':
    //                   this.refreshEntityFiles(this.selectedAsset.id, true);
    //                   break;
    //             default:
    //                 break;
    //         }
    // }

    // private refreshEntityFiles(assetId: number, loadAssetImages: boolean) {
    //     this.entityFileHttpService.getByEntity(this.entityTypeCode, assetId)
    //     .subscribe((entityFiles: Array<EntityFile>) => {
    //         this.existingAssetImages.splice(0, this.existingAssetImages.length);
    //         this.assetImages.forEach((assetImage: AssetImage) => this.existingAssetImages.push(assetImage));
    //         this.assetImages.splice(0, this.assetImages.length);
    //         this.assetFiles.splice(0, this.assetFiles.length);
    //         // this.entityFileMemoryDataSource.clear();
    //         entityFiles.forEach((entityFile: EntityFile) => {
    //             if (entityFile.fileType.startsWith('image/')) {
    //                 let fileContent: any = null;
    //                 this.existingAssetImages.forEach((assetImage: AssetImage) => {
    //                     if (assetImage.entityFile.id === entityFile.id) {
    //                         fileContent = assetImage.fileContent;
    //                     }
    //                 });
    //                 this.assetImages.push(new AssetImage(entityFile, fileContent));
    //             }
    //             else {
    //                 this.assetFiles.push(entityFile);
    //                 // this.entityFileMemoryDataSource.addItem(entityFile);
    //             }
    //         });
    //        // this.fileList.refresh(null);
    //         if (loadAssetImages) this.loadAssetImages();
    //     });
    // }

    private loadAssetImages() {
        if ((this.assetImages !== null) && (this.assetImages.length > 0)) {
            this.imageCount = this.assetImages.length;
            this.imageIndex = 0;
            this.imageLoading = true;
            this.loadAssetImageLoop();
        }
    }

private loadAssetImageLoop() {
        if (this.assetImages.length > this.imageIndex) {
            let assetImage: AssetImage = this.assetImages[this.imageIndex];
            if (assetImage.fileContent === null) {
                this.entityFileHttpService.download(assetImage.entityFile.id).subscribe((image) => {
                    this.createImageFromBlob(assetImage, image);
                    this.loadNextAssetImage();
                });
            }
            else {
                this.loadNextAssetImage();
            }
        }
    }

private createImageFromBlob(assetImage: AssetImage, image: Blob) {
        let reader = new FileReader();
        reader.addEventListener('load', () => {
           // this.images.push(reader.result);
           assetImage.fileContent = reader.result;
           console.log(assetImage);
        }, false);
        if (image) {
           reader.readAsDataURL(image);
        }
    }

private loadNextAssetImage() {
        if (this.imageIndex < (this.assetImages.length - 1)) {
            this.imageIndex++;
            this.loadAssetImageLoop();
        }
        else {
            this.imageLoading = false;
        }
    }

     /*begin dictionary Item*/
     public selectDictionaryItem() {

        this.dictionaryItemList.refresh(null);
        this.dictionaryItemListModal.show();
    }

    public setSelectedDictionaryItem() {
        let items: Array<DictionaryItem> = this.dictionaryItemList.selectedItems;
        this.dictionaryItem = ((items != null) && (items.length === 1)) ? items[0] : null;
        this.name = ((items != null) && (items.length === 1)) ? items[0].name : '';
        this.dictionaryItemListModal.hide();
    }
    /*end asset category*/


     /*begin BRAND */
     public selectBrand() {

        this.brandList.refresh(null);
        this.brandListModal.show();
    }

    public setSelectedBrand() {
        let items: Array<Brand> = this.brandList.selectedItems;
        this.brand = ((items != null) && (items.length === 1)) ? items[0] : null;
        this.brandName = ((items != null) && (items.length === 1)) ? items[0].name : '';
        this.brandListModal.hide();
    }

    /*end BRAND */

    public saveAsset() {
        this.isSaved = true;
        this.assetEmployee.id = this.assetId;
        this.assetEmployee.info = this.info;
        this.assetEmployee.info2019 = this.info2019;
        this.assetEmployee.name = this.name;
        this.assetEmployee.serialNumber = this.serialNumber;
        this.assetEmployee.brandName = this.brandName;
        this.assetEmployee.validated = true;
        this.assetEmployee.dictionaryItemId = this.dictionaryItem != null ? this.dictionaryItem.id : 0;
        this.assetEmployee.brandId = this.brand != null ? this.brand.id : 0;

        if (this.assetEmployee.id > 0) {
             this.assetHttpService.updateAssetEmployee(this.assetEmployee, this.guid)
             .subscribe((assetId: number) => {
                if (assetId > 0){
                    this.notificationService.showSuccess('Datele au fost modificate cu succces!', 'Modificare activ');
                    this.refreshAssets();
                    this.info = '';
                    this.info2019 = '';
                    this.name = '';
                    this.serialNumber = '';
                    this.brandName = '';
                    this.assetId = 0;
                    this.selectedAsset = new AssetEmployeeEdit();
                    this.dictionaryItem = null;
                    this.brand = null;
                    this.isSaved = false;
                    this.loadData();
                }
            }, error => {
                this.notificationService.showError('Eroare!', 'Modificare activ');
            });
            //.subscribe(() => {
                // this.assetHttpService.getDetailById(this.assetEmployee.id)
                //     .subscribe((assetId: number) => {
                //         if (assetId > 0){
                //             this.toastr.success('Datele au fost modificate cu succes!');
                //             this.refreshAssets();
                //             this.isSaved = true;
                //         }
                //     });
            //});
        }
        else {
            this.assetHttpService.addNewAssetEmployee(this.assetEmployee, this.guid)
            .subscribe((assetId: number) => {
                if (assetId > 0){
                    this.notificationService.showSuccess('Datele au fost salvate!', 'Adaugare activ');
                    this.refreshAssets();
                    this.info = '';
                    this.info2019 = '';
                    this.name = '';
                    this.serialNumber = '';
                    this.brandName = '';
                    this.assetId = 0;
                    this.dictionaryItem = null;
                    this.brand = null;
                    this.loadData();
                    this.isSaved = false;
                    this.router.navigate(['/newassetemployee/', this.guid]);
                }
            }, error => {
                this.notificationService.showError('Eroare!', 'Adaugare activ');
            });
        }
    }

    public deleteAssetOp() {
        this.assetHttpService.deleteAssetValidation(this.assetInvFullDetailList.selectedItem.id, this.guid).subscribe( (assetId) => {
            if (assetId > 0){
                this.notificationService.showSuccess('Datele au fost salvate!', 'Stergere activ');
                this.refreshAssets();
                this.info = '';
                this.info2019 = '';
                this.name = '';
                this.serialNumber = '';
                this.brandName = '';
                this.assetId = 0;
                this.dictionaryItem = null;
                this.brand = null;
                this.loadData();
            }
        }, error => {
            this.notificationService.showError('Eroare!', 'Stergere activ');
        });
       
    }

    public onDeleteAssetOp() {
        this.operationType = OperationType.Delete;
        this.confirmationMessage = "Stergeti inregistrarea curenta?";
        this.confirmationModal.show();
    }

    public onConfirmationCanceled() {
        this.operationType = OperationType.NotSet;
        this.confirmationModal.hide();
    }

    public onConfirmationApproved() {

        switch (this.operationType) {
            case OperationType.Delete:
                this.deleteAssetOp();
                break;
            default:
                break;
        }

        this.operationType = OperationType.NotSet;
        this.confirmationModal.hide();
    }

    public clearFilters() {
        this.loadData();
        this.loadTableConfigurationData('user');
        this.assetInvFullDetailList.refresh(null);
    }

    public loadData() {
        this.dashboardHttpService.employeesStatus().subscribe( (res: any[]) => {
          this.itemsInventory = res;
      });
    }

    public loadTableConfigurationData(userRole: string) {
        this.tableDefinitionHttpService.get(1, 1000000, 'id', 'asc', null, null, 'allowAnonymous')
          .subscribe((tableDefinitions: PagedResult<TableDefinition>) => {

            let params: Array<Param> = new Array<Param>();
            params.push(new Param('roleName', userRole));
            this.columnDefinitionHttpService.get(1, 1000000, 'tableDefinitionId', 'asc', params, null, 'allowAnonymous')
              .subscribe((columnDefinitions: PagedResult<ColumnDefinition>) => {
                AppData.UpdateColumnDefinitions(tableDefinitions.items, columnDefinitions.items);
                    this.refreshAssets();
                // this.configValuesHttpService.get(1, 1000000, 'id', 'asc', params)
                //   .subscribe((configValues: PagedResult<ConfigValue>) => {
                //     AppData.UpdateConfigValues(configValues.items);

                //   });
              });
          });
      }

      public get isValid() {
        if (this.name != undefined && this.name != '' && this.name.trim().length > 2) {
            return true;
        } else {
            return false;
        }
    }


    validateName(event: number) {
        // console.log(JSON.stringify(this.dictionaryItem));
        this.dictionaryItem = null;
    }

    validateBrand(event: number) {
        // console.log(JSON.stringify(this.dictionaryItem));
        this.brand = null;
    }
}

enum OperationType {
    NotSet = 1,
    AssetValidation = 2,
    Delete = 3,
    ProcessAssetOp = 4
}